import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../shared/components/RouteError";
import { RoutePending } from "../../shared/components/RoutePending";

/**
 * @purpose Pick which customer to work in (auto-skips with one)
 * @primary Customer cards
 * @persona paola-admin-belora, danilo-tech
 */
export const Route = createFileRoute("/app/")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
